<template>
  <SoFlowSummary :steps="steps" />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoFlowSummary from "@/flows/SoFlowSummary.vue"

  export default defineComponent({
    components: {
      SoFlowSummary,
    },
    inheritAttrs: false,
    props: {
      isMovingIn: {
        type: Boolean,
        required: false,
      },
      completed: {
        type: Boolean,
        required: false,
        default: false,
      },
      hasMeterReading: {
        type: Boolean,
        required: false,
        default: false,
      },
      hasTariff: {
        type: Boolean,
        required: false,
        default: false,
      },
      hasDirectDebit: {
        type: Boolean,
        required: false,
        default: false,
      },
      hasForwardingAddress: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    computed: {
      steps() {
        if (this.isMovingIn) {
          return [
            {
              name: "First date of responsibility",
              completed: this.completed,
            },
            {
              name: "Contact information",
              completed: this.completed,
            },
            {
              name: "Meter reading",
              completed: this.hasMeterReading,
            },
            {
              name: "Quote & set up tariff",
              completed: this.hasTariff,
            },
            {
              name: "Direct Debit Details",
              completed: this.hasDirectDebit,
            },
          ]
        }

        return [
          {
            name: "Last date of responsibility",
            completed: this.completed,
          },
          {
            name: "Meter reading",
            completed: this.hasMeterReading,
          },
          {
            name: "Forwarding address",
            completed: this.hasForwardingAddress,
          },
          {
            name: "New occupier information",
            completed: this.completed,
          },
        ]
      },
    },
  })
</script>
